
/**
 * Enumarete all the possible languages of the APP
 *
 * @export
 * @enum {number}
 */
export enum Language {
  AR = 'ar', // Arabisch (Saudi-Ar.)
  AZ = 'az', // Aserbaidschanisch (Lateinisch)
  BE = 'be', // Weißrussisch
  BG = 'bg', // Bulgarisch
  BR = 'br', // Portugiesisch (Brasilien)
  BS = 'bs', // Bosnisch (Lat., Bosn.-Herzeg.)
  CA = 'ca', // Katalanisch
  CS = 'cs', // Tschechisch
  DA = 'da', // Dänisch
  DE = 'de', // Deutsch
  EL = 'el', // Griechisch
  EN = 'en', // Englisch (Großbritannien)
  ES = 'es', // Spanisch (Traditionelle Sortierung)
  ET = 'et', // Estnisch
  EU = 'eu', // Baskisch
  FA = 'fa', // Farsi
  FI = 'fi', // Finnisch
  FR = 'fr', // Französisch
  GD = 'gd', // Gälisch (Irland)
  HE = 'he', // Hebräisch
  HI = 'hi', // Hindi
  HR = 'hr', // Kroatisch
  HU = 'hu', // Ungarisch
  HY = 'hy', // Armenisch
  ID = 'id', // Indonesisch
  IS = 'is', // Isländisch
  IT = 'it', // Italienisch
  JA = 'ja', // Japanisch
  KA = 'ka', // Georgisch
  KK = 'kk', // Kasachisch
  KM = 'km', // Khmer
  KO = 'ko', // Koreanisch
  LT = 'lt', // Litauisch
  LV = 'lv', // Lettisch
  MR = 'mr', // Marathi
  MK = 'mk', // Mazedonisch
  MN = 'mn', // Mongolisch
  MS = 'ms', // Malaiisch
  MT = 'mt', // Maltesisch
  NL = 'nl', // Niederländisch
  NO = 'no', // Norwegisch
  PL = 'pl', // Polnisch
  PT = 'pt', // Portugiesisch
  RO = 'ro', // Rumänisch (Standard)
  RU = 'ru', // Russisch (Standard)
  SK = 'sk', // Slowakisch
  SL = 'sl', // Slowenisch
  SQ = 'sq', // Albanisch
  SR = 'sr', // Serbisch (Latein)
  SV = 'sv', // Schwedisch
  TA = 'ta', // Tamil
  TL = 'tl', // Tagalog (Philippinen)
  TH = 'th', // Thai
  TK = 'tk', // Turkmenisch
  TR = 'tr', // Türkisch
  UK = 'uk', // Ukrainisch
  UR = 'ur', // Urdu (Pakistan)
  UZ = 'uz', // Usbekisch (Latein)
  VI = 'vi', // Vietnamesisch
  ZH = 'zh' // Chinesisch (VR-China)
}